import axios from '../http'
import * as qiniu from 'qiniu-js'
import { Toast } from 'vant'

export const getQiniuUpToken = async function(type) {
  const url = '/system/qiniu_token/'
  const query = { file_type: type }
  const res = await axios.get(url, { params: query })
  if (!res.code) {
    return res.data
  } else {
    return {}
  }
}

/**
 * 文件上传到七牛
 * @param {*} file 上传的文件
 * @param {*} key 文件上传的key
 * @param {*} token 文件上传的token
 */
export const uploadFile = function(file, key, token, callback) {
  const observalbe = qiniu.upload(file, key, token)
  Toast.loading({
    mask: true,
    message: '上传中...'
  })
  const observer = {
    next(res) {
      // 处理上传进度
      Toast.loading({
        mask: true, message: parseInt(res.total.percent) + '%'
      })
    },
    error(err) {
      console.log(err)
      Toast.clear()
      return callback(err)
    },
    complete(res) {
      console.log(res)
      Toast.clear()
      return callback(null)
    }
  }
  observalbe.subscribe(observer)
}



// WEBPACK FOOTER //
// ./src/util/qiniu.js